import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import winPointsSound from '../../../assets/audio/winpoints.mp3';
import { useUserStore } from '../../../utils/userStore';
import { playAppAudio, isAppAudioEnabled } from '../../../utils/audioManager';
import './success-banner.scss';
import { v2Star } from '../../../assets/images/index';

export interface SuccessBannerProps {
  points?: number;
  animate?: boolean;
  message?: React.ReactNode;
  pointsLabel?: string;
  variant?: 'success' | 'info' | 'error';
}

export const SuccessBanner: React.FC<SuccessBannerProps> = ({ 
  points = 20, 
  animate = false,
  message,
  pointsLabel,
  variant = 'success'
}) => {
  const { t } = useTranslation();
  const { user_attributes } = useUserStore();

  const isLoggedIn = useUserStore((state) => state.isLoggedIn);

  useEffect(() => {
    if (animate && isLoggedIn && isAppAudioEnabled() && variant === 'success') {
      playAppAudio(winPointsSound);
    }
  }, [animate, isLoggedIn, variant]);

  const displayMessage = message || t('v2RespectPoints');
  const displayPointsLabel = pointsLabel || t('v2PointsShorthand');

  return (
    <div className={`v2-success-banner-container v2-success-banner-container--${variant} ${animate ? 'animate-fade-in' : ''}`}>
      <div className="v2-success-banner-inner">
        <div className="v2-success-banner">
          {/* Right-most: Icon (per row-reverse) */}
          <div className="v2-success-banner__icon-wrapper">
            <img src={v2Star} alt="star" className="v2-success-banner__icon" />
          </div>

          {/* Middle: Message */}
          <div className="v2-success-banner__message">
            <span className="v2-success-banner__message-text">{displayMessage}</span>
          </div>

          {variant === 'success' && points > 0 && (
            <div className="v2-success-banner__points-box">
              <span className="v2-success-banner__points-value">{points}</span>
              <span className="v2-success-banner__points-shorthand">{displayPointsLabel}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessBanner;
